module.exports = __webpack_public_path__ + "img/racecourse-flamingoPark-sand-1600.9b3cf473.svg";